import { getCookie } from "~/modules/shared/utils/cookies";
import type { CreateClientConfig } from "./client/client.gen";

// The api group's forgery check accepts same-origin requests on the browser's
// Sec-Fetch-Site alone; this token is what satisfies it on browsers that do
// not send that header.
const fetchWithXsrfToken: typeof fetch = (input, init) => {
	const request = new Request(input, init);
	const token = getCookie("XSRF-TOKEN");
	if (token !== null && !request.headers.has("X-XSRF-TOKEN")) {
		request.headers.set("X-XSRF-TOKEN", token);
	}
	return globalThis.fetch(request);
};

export const createClientConfig: CreateClientConfig = (config) => ({
	...config,
	baseUrl: "",
	headers: { "Content-Type": "application/json", Accept: "application/json" },
	fetch: fetchWithXsrfToken,
});
